import "@/App.css";
import Header from "./landing/Header";
import Hero from "./landing/Hero";
import ClientLogos from "./landing/ClientLogos";
import Services from "./landing/Services";
import About from "./landing/About";
import Testimonials from "./landing/Testimonials";
import Contact from "./landing/Contact";
import Footer from "./landing/Footer";

function App() {
  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <Hero />
      <ClientLogos />
      <Services />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
